module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia10_thumb-6b4296b87cd7fa7d465fa5ebd3f565fd.jpg";